import Vue from 'vue'
import Router from 'vue-router'
import About from './views/About.vue'
import Team from './views/Team.vue'
import Business from './views/Business.vue'
import Technology from './views/Technology.vue'
import Contact from './views/Contact.vue'
import Start from './views/Start.vue'

Vue.use(Router)

export default new Router({

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [{


    path: '/',
    name: 'start',
    component: Start

  },
  {
    path: '/about',
    name: 'about',
    component: About

  },
  {
    path: '/team',
    name: 'team',
    component: Team

  },
  {
    path: '/strategy',
    name: 'technology',
    component: Technology

  },
  {
    path: '/business',
    name: 'business',
    component: Business
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact

  }
  ]
})